import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from 'common/components/organisms/Modal';
import NoteDetails from './NoteDetails';


function NoteDetailsModal(props) {
  const { t } = useTranslation();

  return (
    <Modal
      title={[t('noteDetailsModal.notesTitle'), props.isEditMode ? t('noteDetailsModal.editNoteTitle') : t('noteDetailsModal.createNoteTitle')]}
      padding="0"
      outerPadding="0"
      headerPadding="1rem"
      headerRadius="5px"
      width="60rem"
      close={props.closeModal}
      showHeaderBorder
    >
      <NoteDetails {...props} />
    </Modal>
  );
}

NoteDetailsModal.propTypes = {
  isEditMode: PropTypes.bool,
  closeModal: PropTypes.func,
};

NoteDetailsModal.defaultProps = {
  isEditMode: false,
  closeModal: () => {},
};

export default NoteDetailsModal;
